<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JSR9tC/tc-custom/9780802197085.jpg?1703646799592" alt="This image is the cover for the book Father of the Rain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Father of the Rain
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>New York Times </i></b><b>Editors’ Choice—“a gripping epic about a father and daughter that plumbs the dark side of a family riven by addiction and mental illness” (<i>Entertainment Weekly</i>).</b><br/>  <br/> Gardiner Amory’s life is reeling—Nixon is being impeached, his wife is leaving him, and his worldview is rapidly becoming outdated. His daughter, Daley, has spent the first eleven years of her life negotiating her parents’ conflicting worlds: the liberal, socially committed realm of her mother and the conservative, liquor-soaked life of her father. But when the pair divorces, Gardiner’s basest impulses are unleashed in a deluge, the chasm between all of them widens, and Daley is stretched thinly across it.<br/>  <br/> As she reaches adulthood, Daley rejects the narrow world of her father’s prejudices and embarks on her own life—until Gardiner hits rock bottom. Returning home to help her father get sober, Daley risks everything she’s found beyond him, including a chance at love, in an attempt to repair a trust that was broken long ago . . .<br/>  <br/> In this Winner of the New England Book Award for Fiction, Lily King pulls readers into “a brilliant exploration of the attraction of martyrdom, the intoxication of playing savior. . . . An absorbing, insightful story written in cool, polished prose right to the last conflicted line” (<i>Washington Post</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lily King
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Atlantic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a3872e2